import router from './router'
import store from './store'
import {
  Message
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)
  var token = store.state.oidcStore.access_token; //oidc
  if (token) {
    if (!store.state.menu.menuRouteLoaded) {
      const accessRoutes = await store.dispatch('menu/getSideMenus');
      router.addRoutes(accessRoutes)

      next({ ...to, replace: true })
    }
    else{
      next();
    }
  } else {
    next();
  }
  NProgress.done()
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js